import axios from 'axios';
import Axios from 'axios'
import { RawAxiosInstance } from "./index";
import { HTTP_STATUS_CODES } from 'src/constants/HttpStatusCodes';
import { getAuthorization } from 'src/utils/getAuthorization';
import { useUser } from 'src/contexts/GlobalContext';
import { baseURL } from 'src/constants/apiBaseUrl';

export const responseInterceptors = {
  successInterceptor(response) {
    return response;
  },
  async errorInterceptor(error) {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }
    const statusCode = error?.response?.status;

    if (statusCode) {
      switch (statusCode) {
        case HTTP_STATUS_CODES.CACHED_RESPONSE:
          return Promise.resolve(error.response.data);
        case HTTP_STATUS_CODES.VALIDATION_ERROR:
          console.error(error.response?.data?.meta?.message);
          break;
        case HTTP_STATUS_CODES.SERVER_ERROR:
          console.error(error.response?.data?.meta?.message);
          break;
        case HTTP_STATUS_CODES.NOT_FOUND:
          console.error(error.response?.data?.meta?.message);
          break;
        case HTTP_STATUS_CODES.UN_AUTHORIZED:
          return handleRefreshToken(error)
        case HTTP_STATUS_CODES.UNPROCESSABLE_ENTITY:
          console.error(error.response?.data?.meta?.message);
          break;
        default:
          return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  },
};

export const requestInterceptors = {
  beforeSent(config) {
    const authorization = getAuthorization();

    if (authorization) {



      let branch = localStorage.getItem('branchId')


      config.headers = {
        ...config.headers,
        Authorization: authorization,
        'branch-id': branch
      };
      return config
    } else return config
  },
  onError(error) {
    return Promise.reject(error);
  },
};

const handleRefreshToken = async (error) => {
  const originalConfig = error.config
  const authorization = await getAuthorization('refresh');
  const { localStorage, location } = window

  // Prevent an endless refresh loop if the retried request is also rejected.
  if (originalConfig._retry) {
    return Promise.reject(error);
  }
  originalConfig._retry = true;

  try {
    const res = await Axios.get(baseURL + '/v1/users/refreshToken', {
      headers: { 'Authorization': authorization }
    });
    const refreshed = res?.data?.data;
    if (!refreshed?.accessToken) {
      throw new Error('Refresh token response did not include an access token');
    }

    const { accessToken, refreshToken, admin, menu } = refreshed;
    if (admin) localStorage.setItem('user', JSON.stringify(admin));
    if (menu?.permissions) {
      localStorage.setItem('perms', JSON.stringify(menu.permissions));
    }
    localStorage.setItem('token', accessToken);
    if (refreshToken) localStorage.setItem('refresh_token', refreshToken);

    originalConfig.headers = {
      ...originalConfig.headers,
      'Authorization': 'Bearer ' + accessToken,
    };

    // This return is required: callers such as DashboardLayout#getMe must
    // receive the retried /users/me response so permissions can be restored.
    return Axios.request(originalConfig);
  } catch (refreshError) {
    console.warn('error in refreshing token', refreshError);
    await localStorage.removeItem('user')
    await localStorage.removeItem('token');
    await localStorage.removeItem('refresh_token');
    await localStorage.removeItem('perms');
    await localStorage.removeItem('branchId');
    location.reload();
    return Promise.reject(refreshError);
  }
}
